import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from 'react-s-alert';
import { Field, reduxForm, reset } from 'redux-form';
import classNames from 'classnames';

import BehaviorCategoryModal from './behaviorCategory_Modal';
import { renderTextField } from '../../../components/reduxFields';
import { alertConfirmation, resetFiltersAndSorting } from '../../../actions/utilAction';
import SortingCustom from '../../../components/SortingCustom';
import { getBehaviorCategoryList, deleteBehaviorCategory } from './actions/behaviourCategoryActions';
import PaginatorCustom from '../../../components/paginationCustom';
import SubString from 'add-ellipsis';
import Tooltip from '../../../components/Tooltip';

class BehaviorCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            behaviorCategoryId: null,
        }
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchBehaviorCategory = this.handleSearchBehaviorCategory.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_behaviorCategory && nextProps.saved_behaviorCategory !== this.props.saved_behaviorCategory) {
            this.loadData();
        }
        if (nextProps.deleted_behaviorCategory && nextProps.deleted_behaviorCategory !== this.props.deleted_behaviorCategory) {
            this.loadData();
        }
    }

    componentWillUnmount() {
        Alert.closeAll();
    }

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        this.props.getBehaviorCategoryList(searchObj);
    }

    handleOpen = () => {
        Alert.closeAll();
        this.setState({ open: true, behaviorCategoryId: null });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleSearchBehaviorCategory() {
        return false;
    }

    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleReset = () => {
        Alert.closeAll();
        this.props.dispatch(reset('ManageBehaviorCategoryForm'));
        resetFiltersAndSorting(this.filter, 'id', true);
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.loadData();
    };

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }

    handleEditClick = (event, obj) => {
        Alert.closeAll();
        this.setState({ open: true, behaviorCategoryId: obj.id });
    }

    handleAlertClick = (event, behaviorCategoryId) => {
        this.props.deleteBehaviorCategory(behaviorCategoryId);
        Alert.closeAll();
    }

    handleDeleteClick = (event, obj) => {
        alertConfirmation('Are you sure you want to delete Behavior Category details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.id,
            },
        });
    }

    renderData(behaviorCategoryList) {
        behaviorCategoryList = behaviorCategoryList || [];
        if (!behaviorCategoryList.length) {
            return (
                <tr>
                    <td colSpan="4">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return behaviorCategoryList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>{Obj.behaviorCategoryName}</td>                    
                    <td>
                        {Obj.description && Obj.description.length > 0 ?
                        <Tooltip Description={Obj.description} />
                        : null}
                        {Obj.description != null && Obj.description.length > 25 ? SubString(Obj.description, 25) : Obj.description != null ? Obj.description : 'N/A'}
                    </td> 
                    <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
                    {this.props.updatePermission || this.props.deletePermission ?
                        <td>
                            {this.props.updatePermission ?
                                <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                : null}
                            {this.props.deletePermission ?
                                <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                : null}
                        </td>
                        : null}
                </tr>
            )
        })
    }

    render() {
        const { handleSubmit, behaviorCategoryData } = this.props;
        let behaviorCategoryList = (behaviorCategoryData && behaviorCategoryData.data) || [];
        let behaviorCategoryMeta = (behaviorCategoryData && behaviorCategoryData.meta) || null
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <div>
                <h2 className="page_title">Manage Behavior Category</h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="modalwindow">
                            <div className="row">
                                {this.props.addPermission ?
                                    <div className="col-sm-5">
                                        <RaisedButton label="Add Behavior Category" primary={true} onTouchTap={this.handleOpen} />
                                    </div>
                                    : null}
                                <div className="col-sm-7">
                                    <div className="row end-flex">
                                        <div className="col-sm-6 mtm-27">
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchBehaviorCategory)}>
                                                <Field
                                                    name="behaviorCategory"
                                                    floatingLabelText="Search"
                                                    maxLength='15'
                                                    onChange={this.handleSearchChange}
                                                    component={renderTextField}
                                                />
                                            </form>
                                        </div>
                                        <div className="reset-btn col-sm-3 btn_rt">
                                            <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.open && <BehaviorCategoryModal behaviorCategoryId={this.state.behaviorCategoryId} closeDialog={this.handleClose} />}
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    <table className={tableClass}>
                                        <thead>
                                            <tr>
                                                <th width="30%"><SortingCustom noSort={!behaviorCategoryList.length} setSortColumn={this.setSortColumn} columnName='name' displayName='Name' /></th>
                                                <th width="40%"><SortingCustom noSort={!behaviorCategoryList.length} setSortColumn={this.setSortColumn} columnName='description' displayName='Description' /></th>
                                                <th width="20%">Active</th>
                                                {this.props.updatePermission || this.props.deletePermission ?
                                                    <th width="10%">Actions</th>
                                                    : null
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderData(behaviorCategoryList)}
                                        </tbody>
                                    </table>
                                    {behaviorCategoryMeta && behaviorCategoryMeta['totalPages'] ?
                                        <PaginatorCustom data={behaviorCategoryMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

BehaviorCategory = reduxForm({
    form: 'ManageBehaviorCategoryForm',
})(BehaviorCategory);

function mapStateToProps(state) {

    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "MASTERS_DATA_COLLECTION");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "MASTERS_DATA_COLLECTION_BEHAVIOR_CATEGORY_LIST" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_BEHAVIOR_CATEGORY_LIST_ADD")[0].permission : false;
    let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_BEHAVIOR_CATEGORY_LIST_UPDATE")[0].permission : false;
    let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_BEHAVIOR_CATEGORY_LIST_DELETE")[0].permission : false;

    // End For Role Permission

    return {
        loading: state.behaviorCategory.loading,
        behaviorCategoryData: state.behaviorCategory.behaviorCategoryList,
        saved_behaviorCategory: state.behaviorCategory.saved_behaviorCategoryList,
        deleted_behaviorCategory: state.behaviorCategory.deleted_behaviorCategoryList,
        addPermission: addPermission, // For Role Permission
        updatePermission: updatePermission, // For Role Permission
        deletePermission: deletePermission // For Role Permission
    }
}

export default connect(mapStateToProps, { getBehaviorCategoryList, deleteBehaviorCategory })(BehaviorCategory);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/behaviourCategory/index.js